import { Range } from '../../entities/range.model';
import { Table } from '../../entities/table.model';


export class TaxonomiesTable extends Table<{ [taxonomyId: number]: number[]; }> {
  private fieldTaxonomiesCache: { [fieldId: number]: number[]; } = {};
  private taxonomyIds: number[] = [];

  constructor(
    range: Range) {
    super(range, false, {});
  }

  add(taxonomyId: number, fieldIds: number[]): boolean {
    if (!this.exists(taxonomyId)) {
      if (this.containsData) {
        this.range.rowCount++;
      } else {
        this.containsData = true;
      }

      this.cache[taxonomyId] = fieldIds;
      this.taxonomyIds.push(taxonomyId);

      for (const fieldId of fieldIds) {
        this.addFieldTaxonomy(fieldId, taxonomyId);
      }

      return true;
    }

    return false;
  }

  remove(taxonomyId: number): boolean {
    if (this.exists(taxonomyId)) {
      const fieldIds = this.cache[taxonomyId]
        .filter((id, index, arr) => arr.indexOf(id) === index);

      for (const fieldId of fieldIds) {
        this.removeFieldTaxonomy(fieldId, taxonomyId);
      }

      delete this.cache[taxonomyId];
      this.taxonomyIds.splice(this.taxonomyIds.indexOf(taxonomyId), 1);

      if (this.range.rowCount == 2 /* header + one row */) {
        this.containsData = false;
      } else {
        this.range.rowCount--;
      }

      return true;
    }

    return false;
  }

  getFieldIds(taxonomyId: number): number[] {
    const fieldIds = this.cache[taxonomyId];
    return fieldIds ? [...fieldIds] : undefined;
  }

  getTaxonomyIds(fieldId: number): number[] {
    const taxonomyIds = this.fieldTaxonomiesCache[fieldId];
    return taxonomyIds ? [...taxonomyIds] : undefined;
  }

  getRowPosition(taxonomyId: number): number {
    if (this.exists(taxonomyId)) {
      return this.taxonomyIds.indexOf(taxonomyId);
    }

    return -1;
  }

  exists(taxonomyId: number): boolean {
    return this.cache.hasOwnProperty(taxonomyId);
  }

  private addFieldTaxonomy(fieldId: number, taxonomyId: number): void {
    const fieldTaxonomies = this.fieldTaxonomiesCache[fieldId];

    if (!fieldTaxonomies) {
      this.fieldTaxonomiesCache[fieldId] = [taxonomyId];
    } else if (fieldTaxonomies.indexOf(taxonomyId) === -1) {
      fieldTaxonomies.push(taxonomyId);
    }
  }

  private removeFieldTaxonomy(fieldId: number, taxonomyId: number): void {
    const fieldTaxonomies = this.fieldTaxonomiesCache[fieldId];

    fieldTaxonomies.splice(fieldTaxonomies.indexOf(taxonomyId), 1);

    if (fieldTaxonomies.length === 0) {
      delete this.fieldTaxonomiesCache[fieldId];
    }
  }
}